import React, { useMemo } from 'react';
import { SelectButton } from 'primereact/selectbutton';
import GenericTableFilter from '../../../../../components/common/GenericTableFilter';
import { FORM_TYPE } from '../../../../../utils/formDateChangeConstants';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const WarrantyDateChangeApprovalFilters = ({ formTypeFilter, onFormTypeChange, filterFields, onApplyFilters, onResetFilters }) => {
    const { th } = useLanguage();

    const customFilterTypes = useMemo(() => ({ startDate: 'date', endDate: 'date', dateField: 'select' }), []);

    const formTypeOptions = useMemo(
        () => [
            { label: th('common.all'), value: null },
            { label: th('formDateChangeRequest.formType.vaf'), value: FORM_TYPE.VAF },
            { label: th('formDateChangeRequest.formType.psi'), value: FORM_TYPE.PSI },
            { label: th('formDateChangeRequest.formType.cvrf'), value: FORM_TYPE.CVRF }
        ],
        [th]
    );

    return (
        <div className="mb-3">
            <div className="flex align-items-center justify-content-between flex-wrap gap-3 mb-2">
                <SelectButton value={formTypeFilter} options={formTypeOptions} onChange={(e) => onFormTypeChange(e.value)} allowEmpty={false} />
            </div>
            <GenericTableFilter filterFields={filterFields} initialFilters={{}} onApplyFilters={onApplyFilters} onResetFilters={onResetFilters} customFilterTypes={customFilterTypes} />
        </div>
    );
};

export default WarrantyDateChangeApprovalFilters;
